import {
    Box,
    Grid2,
} from '@mui/material'
import CourseCard from '../../shared/components/CourseCard'

import CustomDivider from '../../shared/utils/CustomDivider';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import { useNavigate } from 'react-router-dom';
import { NavigateButton } from '../../shared/utils/CustomButton';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';



const CourseScroller = ({ content, courses, isLoading,category }) => {
    const navigate = useNavigate()

    return (
        <Box>
            <HorizontalScroll heading={content?.data?.subheading} subheading={content?.data?.heading} size={3}>
                {!isLoading && (
                    courses?.slice(0,6)?.map((item, index) => (
                        <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}>
                            <CourseCard item={item} />
                        </Grid2>
                    ))
                )}
                {
                    isLoading && [...Array(6)].map((_, index) => (
                        <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                }
            </HorizontalScroll>

            <CustomDivider orientation='horizontal' size={"30px"} />

            <NavigateButton onClick={() => navigate(`/Courses/${category}`)} />
        </Box>

    )
}

export default CourseScroller